<script>
	import { onMount } from 'svelte';
	import * as helpers from './helpers.js';
	import axios from 'axios';
	import lunr from 'lunr';
	import PocketBase from 'pocketbase';
	export let isPantheonEnv;
	export let searchSvgUrl;
	export let resultsPlaceholder;
	export let school;
	export let indices;

	let pb;
	pb = new PocketBase(
		isPantheonEnv === 0
			? process.env.POCKETBASE_DEV
			: process.env.POCKETBASE_PROD
	);

	console.log('pb = ', pb);

	const sessionId = helpers.getSessionId();
	const debounceTime = 250;
	const minimumQueryChars = 3;

	let index = [];
	let lunrIndex = [];
	let activeIndex = 0;
	let showResults = true;
	let noResultsFound = false;
	let hits = [];
	let showResultsPlaceholder = true;
	let searchInputValue = '';
	let searchTimeout;
	let querySuggestions = [];
	let activeQuery;

	onMount(async () => {
		for (const [i, index] of indices.entries()) {
			const response = await axios.get(index.index_url);
			console.log(`response ${i} = `, response);

			indices[i].index = i === 1 ? response.data.pages : response.data;

			indices[i].lunr_index = lunr(function () {
				this.ref('id'); // unique ID for each doc

				// Define searchable fields
				this.field('title', { boost: 10 });
				this.field('content');
				this.field('meta', { boost: 5 });

				// Add documents to index
				indices[i].index.forEach((doc) => this.add(doc));
			});
		}

		console.log(
			'indices[activeIndex].lunr_index = ',
			indices[activeIndex].lunr_index
		);

		lunrIndex = indices[activeIndex].lunr_index;
		index = indices[activeIndex].index;

		if (pb) {
			const response = await helpers.fetchQuerySuggestions(pb, school);
			if (response) {
				querySuggestions = response;
			}
			console.log('querySuggestions = ', querySuggestions);
		}
	});

	$: showResultsPlaceholder = searchInputValue.length < minimumQueryChars;
	$: if (searchInputValue) {
		if (searchInputValue.length >= minimumQueryChars) {
			clearTimeout(searchTimeout);
			searchTimeout = setTimeout(() => {
				performSearch(searchInputValue);
			}, debounceTime);
		} else {
			hits = [];
		}
	}
	$: if (activeIndex !== undefined && activeIndex !== null) {
	}

	function handleIndexChange(event) {
		console.log('id = ', event.target.value);
		console.log('activeIndex = ', activeIndex);
		if (event.target.value === activeIndex) return;
		showResults = false;
		hits = [];
		index = indices[activeIndex].index;
		performSearch(searchInputValue);
	}

	async function performSearch(query) {
		// console.log('activeIndex = ', activeIndex);

		query = query.toLowerCase().trim();
		console.log('query = ', query);
		const results = lunrIndex.search(query);
		// console.log('results = ', results);

		hits = results.map((result) => {
			return index.find((doc) => doc.id === parseInt(result.ref));
		});

		console.log('helpers.programKeywords = ', helpers.programKeywords);
		console.log(
			'helpers.programKeywords.includes(query) = ',
			helpers.programKeywords.includes(query)
		);

		const querySplit = query.split(" ")
		const programKeywordsMatch = querySplit.every(word => helpers.programKeywords.includes(word.toLowerCase()));
		const campusKeywordsMatch = querySplit.every(word => helpers.campusKeywords.includes(word.toLowerCase()));

		console.log("programKeywordsMatch = ", programKeywordsMatch);
		console.log("campusKeywordsMatch = ", campusKeywordsMatch);
		

		if (programKeywordsMatch) {
			hits.sort((a, b) => {
				const aScore = helpers.sortProgramQuery(a.url);
				const bScore = helpers.sortProgramQuery(b.url);
				return aScore - bScore;
			});
		} else if (campusKeywordsMatch) {
			hits.sort((a, b) => {
				const aScore = helpers.sortCampusQuery(a.url);
				const bScore = helpers.sortCampusQuery(b.url);
				return aScore - bScore;
			});
		} else {
			hits = hits.map((item, i) => ({
				...item,
				ranking: i + 1, // 1-based rank
			}));
		}

		const resultsCount = hits.length;
		hits = hits.slice(0, 30);
		// console.log('hits = ', hits);
		console.log('resultsCount = ', resultsCount);

		// Generate and attach snippet only for matched index types
		hits = hits.map((item) => {
			let snippetMatch = false;
			let matchedKey = '';
			if (item.meta?.toLowerCase().includes(query)) {
				matchedKey = item.meta;
				snippetMatch = true;
			} else if (item.content?.toLowerCase().includes(query)) {
				matchedKey = item.content;
				snippetMatch = true;
			}
			if (snippetMatch) {
				const raw = helpers.generateSnippet(matchedKey, query);
				return { ...item, snippet: helpers.highlightQuery(raw, query) };
			}
			return item;
		});

		console.log('hits = ', hits);
		noResultsFound = hits.length === 0;

		if (!showResults) {
			showResults = true;
		}

		if (pb) {
			try {
				const queryObject = {
					term: query.trim(),
					resultsCount,
					sessionId: sessionId,
				};
				console.log('queryObject = ', queryObject);

				const pbResponse = await pb
					.collection(indices[activeIndex].pb_collection)
					.create(queryObject);
				console.log('pbResponse = ', pbResponse);
				activeQuery = pbResponse;
			} catch (err) {
				console.error('Failed to log query:', err);
			}
		}
	}

	async function searchResultClicked(hit) {
		if (pb) {
			try {
				console.log('clicked hit = ', hit);
				const pbCollection = indices[activeIndex].pb_collection;
				// Send analytics data to pocketbase endpoint
				const pbResponse = await pb
					.collection(pbCollection)
					.update(activeQuery.id, {
						producedAClick: true,
						clickedResultDetails: hit,
					});
				console.log('pbResponse = ', pbResponse);

				const conversionCookieKey = 'clicked_search_result';
				const conversionCookie = {
					query_id: activeQuery.id,
					page_id: hit.id,
					collection_name: pbCollection,
				};
				localStorage.setItem(
					conversionCookieKey,
					JSON.stringify(conversionCookie)
				);
			} catch (err) {
				console.error('Failed to log query:', err);
			}
		}
	}
</script>

<div id="search-wrap" class="search-wrapper">
	<label for="search-input">
		Search
		<img src={searchSvgUrl} alt="" />
		<input
			id="search-input"
			type="text"
			placeholder={indices[activeIndex].placeholder}
			aria-label="Search"
			name="s"
			bind:value={searchInputValue}
		/>
	</label>
	<button class="search-close" on:click={() => (searchInputValue = '')}>
		<span>Close Search</span>
	</button>
	<ul id="search-ui">
		<li class="index-selector">
			<span style="margin-right: 20px;">Search within:</span>
			{#each indices as index}
				<label>
					<input
						type="radio"
						name="index-selection"
						value={index.id}
						bind:group={activeIndex}
						on:change={handleIndexChange}
					/>
					{index.label}
				</label>
			{/each}
		</li>
		<li>
			{#if querySuggestions.length > 0}
				<ul id="suggested-terms">
					<span>Suggested searches:</span>
					{#each querySuggestions as suggestion}
						<li class="suggested-term">
							<button
								class="suggested-term-btn"
								on:click={() => (searchInputValue = suggestion.term)}
							>
								{suggestion.term}
							</button>
						</li>
					{/each}
				</ul>
			{/if}
		</li>
		<li id="results-container">
			<ul id="search-results">
				{#if showResultsPlaceholder}
					<li id="placeholder">{resultsPlaceholder}</li>
				{:else if noResultsFound}
					<li>
						No results found for "{searchInputValue}". Can't find what you're
						looking for? Call
						<a href="tel:+1-866-508-2684">866-508-2684</a> or start a live chat.
					</li>
				{:else if showResults === true}
					{#each hits as hit}
						<li>
							<p class="hit-type">{helpers.parseHitTypeWcuDotEdu(hit)}</p>
							<a
								href={hit.url.relative}
								on:click={() => searchResultClicked(hit)}
							>
								<h2>{@html hit.title}</h2>
								<p>
									{@html hit.snippet || hit.meta}
								</p>
							</a>
						</li>
					{/each}
				{/if}
			</ul>
		</li>
	</ul>
</div>
